import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, effect } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { NgbAlert, NgbCollapse, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { CampaignService } from 'src/app/_services/campaign.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import { WebbtreeVerifiedService } from 'src/app/_services/webbtree-verified.service';
import { CandidateEmailComponent } from 'src/app/candidate/candidate-email/candidate-email.component';
import { FilterMapperService } from 'src/app/projects/services/filter-mapper.service';
import { TimezonesService } from 'src/app/timezones.service';
import { AggregateRequestStoreService } from '../../store/aggregate-request-store.service';
import { CandidateActionService } from 'src/app/_services/candidate-action.service';
import { HireContactViewInboundComponent } from '../hire-contact-view-inbound/hire-contact-view-inbound.component';
import { CandidateSelectionService } from 'src/app/projects/services/candidate-selection.service';
import { CommonModule } from '@angular/common';
declare const clevertap;

@Component({
  selector: 'app-hire-candidate-contact-view',
  imports: [NgbCollapse, ReactiveFormsModule, NgbAlert, MatTooltipModule, HireContactViewInboundComponent, NgbTooltip, CommonModule],
  templateUrl: './hire-candidate-contact-view.component.html',
  styleUrl: './hire-candidate-contact-view.component.scss',
})
export class HireCandidateContactViewComponent implements OnInit, OnChanges, OnDestroy {
  isCollapsed: boolean = false
  isCollapsed2: boolean = true
  isCollapsed3: boolean = true;
  isCollapsed6: boolean = true;
  isCollapsed4: boolean = false;
  isCollapsed5: boolean = true;
  /**Elastic id of user */
  elasticid: string = '';

  /**Varaible used to know the location current location of contact slider */
  enrichedfrom: string = 'person-search-listing';
  /**Reveal Contact api pending status */
  isRevealContactLoading: boolean = false;
  isRevealContactEmailLoading: boolean = false;

  /**
   * TRMS-2797: true while a FullEnrich fallback job (kicked off in the background when
   * SignalHire alone left a gap) is still in flight for this candidate - either just triggered
   * by revealContact(), or detected as already in-flight via checkFullEnrichPendingStatus().
   */
  isFullEnrichPending: boolean = false;

  /**
   * TRMS-2797: Message shown while a FullEnrich fallback job is pending. The default promises no email -
   * it's what retry (which sends none) and a reopened pending candidate show. A single reveal that goes
   * pending overwrites it with the backend's own message (that flow does email the result).
   */
  readonly defaultFullEnrichPendingMessage: string = "We're still working on getting these details. We'll email you as soon as they're ready.";
  fullEnrichPendingMessage: string = this.defaultFullEnrichPendingMessage;

  /**List of providers from which gives data on reveal */
  contactProviderData: string[] = [];
  /**
 * Required details of candidate
 * Sent from person search listing, email campaign candidate slider, and talentpool candidate slider
 * Following keys should be present in candidateDetails object: idinindex (elasticid), candidatenumber, iswebbtreeverified, usedWebbtreeIntroduction, revealContactAttempted
*/
  @Input() candidateDetails;
  /**Candidate number of candidate */
  candidateNumber: string = '';

  /**Used to show custom toast message on successfull reveal */
  customToast: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';

  /**Event to notify person-search-listing, candidate-list, and email campaign-target-listing */
  @Output() handleOutputEvent = new EventEmitter<{ action: string, data: any }>();

  /**Total available credits user have */
  totalCreditsAvailable: number = null;
  isteamMember: boolean = false;
  /**All contact information of user */
  allExistingContactDetails: any;

  /**Phone number of candidate */
  phones: any[] = [];
  /**Personal email's of candidate */
  personal_email: any[] = [];
  /**Professional email of candidate */
  work_email: any[] = [];
  /**Any of contact details present or not except added-manually contact */
  availableContactDetailNotManual: boolean = false;
  isExtensioninstalled: any;
  /**Is any of verified, introduction or contact reveal(got contact details) has success */
  hasAnyOfRequestSuccess: boolean = false;

  /**Preview api pending status - true while checkFullEnrichPendingStatus() works out this candidate's reveal state */
  isPreviewPending: boolean = false;
  /** Reveal was requested before that check finished - run it once the state is known. */
  private revealAfterStatusCheck: boolean = false;
  /** Value changes onClick of close icon */
  isCloseNoDataFound: boolean = false;
  /**Is current user allowed for webtree verified and webtree introduction or not */
  internalUser: boolean = false;
    /**Object used to know about preview of contact details. */
  isPreviewAvailable: { work_email: boolean, personal_email: boolean, phone: boolean } = { work_email: false, personal_email: false, phone: false }
  /**Fetch existing contact details api pending status */
  isFetchExistingContactPending: boolean = false;
  CREDITS_REQUIRED = GlobalService.ENRICHMENT_CREDITS;
  /**Webtree verified api pending status */
  isVerifiedLoading: boolean = false;
  /** Form used for text message written by user in Webbtree Introduction */
  webbtreeIntroductionMessageForm: UntypedFormControl = new UntypedFormControl(null, Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(1000)]));
    deb = new Subject<any>();
  @ViewChild('noCreditsCE') noCreditsCE: TemplateRef<any>;
  userData: any;
    /**Webtree Introduction date and time slots */
    dateTimeMasterForm = this.fb.group({
      dateTimeSlot_0: this.fb.group({
        date: new UntypedFormControl(moment().add(2, 'days').format('YYYY-MM-DD')),
        fromTime: new UntypedFormControl('14:00'),
        toTime: new UntypedFormControl('16:00'),
        timezone: new UntypedFormControl(TimezonesService.timeZoneAbbrevation([Intl.DateTimeFormat().resolvedOptions().timeZone]))
      })
    })

    minDateIntro: string = moment().add(2, 'days').format('YYYY-MM-DD')
    maxDateIntro: string = moment().add(30, 'days').format('YYYY-MM-DD')
    timezones: string[] = [];
      /**An array of objects of date, fromtime, totime, and timezone, Used to send in request body */
  dateTimeSlotsArray: any[] = [];
  isIntroductionLoading: boolean = false;
  searchType: string = '';
  @Input() calledFrom: string = '';
  revealContactCandidateSubscription: Subscription | null = null;

  constructor(private localstorageservice: LocalStorageService, private route: ActivatedRoute, private personSearchService: PersonSearchService, private transactionservice: TransactionService, private campaignService: CampaignService, private candidateservice: CandidateService,
        public requestContract: WebbtreeVerifiedService, private modalService: NgbModal,  private fb: UntypedFormBuilder, private filterService: FilterMapperService,
        private aggRequestService: AggregateRequestStoreService, private candidateSelectionService: CandidateSelectionService

  ) {
    // Reveal contact already notifies TransactionService's own credit-consumed refresh
    // (see CreditActivityService); reacting to the shared signal here - instead of this
    // component also calling /paymentflow/fetchcurrentplancredits itself - avoids firing the
    // credits API twice for the same reveal.
    effect(() => {
      const creditsData = this.transactionservice.credits();
      if (creditsData) {
        this.totalCreditsAvailable = creditsData.balancebasiccontactenrichmentcredits;
        if (creditsData.teamadmindetails) {
          this.isteamMember = true;
        }
      }
    });
  }
  ngOnInit() {
    this.timezones = TimezonesService.timeZoneAbbrevation();
    this.internalUser = this.isCurrentUserInternal();
    this.userData = this.localstorageservice.getItem('userdata');
    this.totalCreditsAvailable = this.userData['balancebasiccontactenrichmentcredits'];
    this.searchType = this.route.snapshot.queryParams['type'];

    this.getEnrichedType();
    this.loadCandidateContactData();
    this.revealContactCandidateSubscription = this.candidateSelectionService.getRevealContactCandidate().subscribe((data: any) => {
      if (this.shouldHandleRevealContactEvent(data)) {
        this.isCollapsed6 = false;
        this.candidateSelectionService.clearRevealContactCandidate();
        this.revealContact();
      };
    });
  }

  ngOnDestroy() {
    this.revealContactCandidateSubscription?.unsubscribe();
  }

  /**
   * candidateDetails is passed in via @Input() and this component is NOT re-created when the
   * user navigates next/prev in the slider (only the input changes) - so ngOnInit() alone
   * only ever runs for the very first candidate. Without ngOnChanges, the reveal-contact
   * section keeps showing stale data from whichever candidate was loaded first.
   */
  ngOnChanges(changes: SimpleChanges) {
    const change = changes['candidateDetails'];
    // The slider re-creates the candidate object whenever any of its own calls resolve
    // (explanation, job fitness, ...). Only reload when it's a different candidate or its
    // contact data actually changed - otherwise each of those re-ran the pending check and
    // wiped the reveal state shown here.
    // My Candidates is not exempt: it opens with the list item loaded with the page, and the slider's own getcandidatedetails
    // later brings in what finished since (Reveal Contact flag + saved contacts). Skipping the reload here left the flag set
    // with no contacts loaded, so a candidate whose FullEnrich had finished showed "Contact details unavailable" until refresh.
    if (change && !change.firstChange && this.contactStateKey(change.currentValue) !== this.contactStateKey(change.previousValue)) {
      this.loadCandidateContactData();
    }
  }

  private contactStateKey(candidate: any): string {
    return JSON.stringify([
      this.getCandidateElasticId(candidate),
      candidate?.revealContactAttempted,
      candidate?.existingContactDetails,
      candidate?.contactdetails
    ]);
  }

  /**
   * (Re)initializes everything that depends on candidateDetails: elasticid, contact details
   * (existing/revealed), reveal-success flags, candidate number. Called on first load
   * (ngOnInit) and again every time candidateDetails changes (ngOnChanges), e.g. via the
   * slider's back/forward navigation.
   */
  private loadCandidateContactData() {


    // Reset state left over from the previous candidate so stale data doesn't flash
    // while the new candidate's details are (re)computed/fetched.
    this.contactProviderData = [];
    this.phones = [];
    this.personal_email = [];
    this.work_email = [];
    this.availableContactDetailNotManual = false;
    this.hasAnyOfRequestSuccess = false;
    this.isFullEnrichPending = false;
    this.fullEnrichPendingMessage = this.defaultFullEnrichPendingMessage;
    this.isPreviewPending = false;
    this.revealAfterStatusCheck = false;

    this.elasticid = this.candidateDetails?.idinindex || this.candidateDetails?.elasticid || this.candidateDetails?.id || '';
    if(this.filterService.isHirePieplineListing() || this.filterService.isHireMyCandidatesListing()) {
      this.elasticid = this.candidateDetails?.basicdetails?.elastic_id || '';
    }

    //In case of person-search listing
    if (this.enrichedfrom == 'pipeline-listing' || this.filterService.isHirePieplineListing() || this.filterService.isHireMyCandidatesListing()) {
          const sliderData = this.candidateDetails.contactdetails;
    let tempArr = [];
    if (sliderData?.emails?.existingDetails) {
      tempArr = tempArr.concat(sliderData.emails.existingDetails);
    }
    if (sliderData?.contactnumbers?.existingDetails) {
      tempArr = tempArr.concat(sliderData?.contactnumbers?.existingDetails);
    }
    this.candidateDetails['existingContactDetails'] = tempArr;
      this.candidateDetails?.revealContactAttempted ? this.getAllContactDetailsV2() : this.segregateContactDetails(this.candidateDetails?.existingContactDetails);
    }
    else
      this.segregateContactDetails(this.candidateDetails?.existingContactDetails)

    if(!this.internalUser){
      this.hasAnyOfRequestSuccess = (this.hasAnyOfRequestSuccess || this.candidateDetails?.iswebbtreeverified || this.candidateDetails?.usedWebbtreeIntroduction);
    } else{
      this.hasAnyOfRequestSuccess = this.hasAnyOfRequestSuccess ||  this.candidateDetails?.revealContactAttempted;
    }

    //Get preivew only if user not attempted for reveal
    // (!this.candidateDetails?.revealContactAttempted) && this.getPreviewContactDetailV2();

    // TRMS-2797: check if a FullEnrich fallback job triggered by an earlier reveal click is
    // still in flight for this candidate, so switching candidates / reopening / refreshing shows
    // the "still working on it" state instead of resetting to the initial Reveal Contact button.
    // Not gated on revealContactAttempted: this view sets that flag itself as soon as ANY contact is saved, and SignalHire's
    // arrives first while FullEnrich is still running - so a candidate with a partial result looked finished, its running
    // request was never looked for, and the slider offered Retry instead of "still working on it".
    // Never for upload/inbound candidates - they aren't revealed through providers at all (the
    // template shows app-hire-contact-view-inbound for them instead of the reveal section).
    !this.isInboundCandidate() && this.checkFullEnrichPendingStatus();

    this.candidateNumber = this.candidateDetails?.candidatenumber || this.candidateNumber;
  }

  private shouldHandleRevealContactEvent(data: any): boolean {
    if (!data?.candidate || data?.type !== 'reveal-contact') {
      return false;
    }
    const eventCandidateId = this.getCandidateElasticId(data.candidate);
    return !eventCandidateId || !this.elasticid || eventCandidateId === this.elasticid;
  }

  private isInboundCandidate(): boolean {
    return this.calledFrom == 'project-upload-candidates' || this.calledFrom == 'project-inbound-applications';
  }

  private getCandidateElasticId(candidate: any): string {
    return candidate?.basicdetails?.elastic_id || candidate?.idinindex || candidate?.elasticid || candidate?.id || '';
  }

  /**
   * Fetches the current basic-contact-enrichment credit balance fresh from the API and reports
   * whether it covers `required` credits, via `callback`. -1 means unlimited (team/plan sentinel
   * - see bulk-reveal-modal.component.ts for the same check). Always hits the API rather than
   * reading totalCreditsAvailable, since this gates whether the reveal proceeds and must reflect
   * the true current balance, not whatever was last pushed into the shared signal.
   */
  private checkHasEnoughCredits(required: number, callback: (hasEnough: boolean) => void): void {
    this.transactionservice.updateAllCreditsForCurrentUser().subscribe((creditsData: any) => {
      const available = creditsData?.balancebasiccontactenrichmentcredits;
      callback(available === -1 || available >= required);
    });
  }

  /**
   * Reveal Contact-details revamp
   */
  revealContact() {
    // Every reveal path (button, card icon) ends up here, so this is where a second paid reveal
    // for the same candidate is refused: already loading, already revealed, FullEnrich still
    // working, or a reveal already fired for it this session (this slider or bulk, possibly in
    // a slider instance that has since been closed).
    if (this.isRevealContactLoading || this.candidateDetails?.revealContactAttempted || this.isFullEnrichPending
      || this.candidateSelectionService.isRevealSubmitted(this.elasticid)) {
      return;
    }
    this.checkHasEnoughCredits(this.CREDITS_REQUIRED.CONTACT_PARTNER, (hasEnough) => {
      if (!hasEnough) {
        this.toastmessage('You don`t have enough credits!', 'error');
        return;
      }
      this.doRevealContact();
    });
  }

  private doRevealContact() {
    let currentRegion = this.localstorageservice.getItem('region');
    const redirectSource = this.route.snapshot.queryParams['redirectSource'];



    const data = {
      elastic_id: this.elasticid,
      enrichedfrom: this.enrichedfrom,
    }
    this.isRevealContactLoading = true;
    // The user can move to another candidate before this resolves - track it by the id it was sent for.
    const revealedElasticId = this.elasticid;
    this.candidateSelectionService.markRevealSubmitted([revealedElasticId]);
    setTimeout(() => {
      this.isRevealContactEmailLoading = true
    }, 7000)

    this.personSearchService.revealContactV2(data).subscribe((result: any) => {
      if (result && result.body.pending) {
        this.candidateSelectionService.markRevealSeenPending(revealedElasticId);
      } else {
        this.candidateSelectionService.clearRevealSubmitted(revealedElasticId);
      }
      if (result && result.body.providers) {
        this.contactProviderData = result?.body?.providers;
        this.candidateDetails['revealContactAttempted'] = 1;

        result.body.message['usedWebbtreeIntroduction'] = this.candidateDetails["usedWebbtreeIntroduction"] ? 1 : 0;
        result.body.message['iswebbtreeverified'] = this.candidateDetails["iswebbtreeverified"] ? 1 : 0;
        result.body.message['revealContactAttempted'] = this.candidateDetails['revealContactAttempted'] ? 1 : 0;
        // Once reveal is completed will enabled retry reveal
        result.body.message['isRevealRetryAvailable'] = 1;

        this.candidateNumber = result.body.message.candidatenumber;
        // this.getAllContactDetailsV2('revealContactV2');

        this.segregateContactDetails(result?.body?.message?.existingContactDetails);
        this.candidateDetails = result.body.message;
        this.sendMessagetoChrome();

        this.customToast = true;
        this.toastmessage('', 'custom');

        const eventdata = {
          action: 'append-data',
          data: result.body.message
        }
        this.isRevealContactLoading = false;
        this.isRevealContactEmailLoading = false;
        this.aggRequestService.updateCandidate(this.elasticid,this.candidateDetails)
        this.handleOutputEvent.emit(eventdata);
        /**
         * reveal contact
         */
        const revealParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Candidate ID": this.elasticid,
          "Reveal Time": moment().format(),
          "Request Type": "Contact Partner",
          "Source": "Platform",
          "Reveal Complete": "Yes",
        }
        clevertap.event.push('Explore Contact', revealParams);


      }
      else if (result && result.body.pending) {
        // TRMS-2797: SignalHire alone didn't fill every gap - backend fired a FullEnrich
        // fallback in the background and responded immediately with a pending status instead
        // of making the browser wait (FullEnrich itself resolves async via webhook, 45-210s).
        this.isFullEnrichPending = true;
        this.fullEnrichPendingMessage = result.body.message || this.fullEnrichPendingMessage;

        if (result.body.partialContactDetails) {
          this.candidateDetails['contactDetails'] = { ...(this.candidateDetails['contactDetails'] || {}), ...result.body.partialContactDetails };
          this.segregateContactDetails(this.mapPartialContactDetailsToContactList(result.body.partialContactDetails));
        }

        this.toastmessage(this.fullEnrichPendingMessage, 'success');
        this.isRevealContactLoading = false;
        this.isRevealContactEmailLoading = false;
      }
      // const ele = document.getElementById('contact-dropdown');
      // ele && ele.classList.remove('show')
      // this.isRevealContactLoading = false; Will set value false, in getAllContactDetailsV2()
    }, (error) => {
      // 409 = backend reveal lock held: another reveal for this candidate is genuinely running,
      // so it still counts as in flight. Anything else means nothing was started - allow again.
      if (error.status !== 409) {
        this.candidateSelectionService.clearRevealSubmitted(revealedElasticId);
      }
      if (error.status === 400 || error.status === 500) {
        //Api failure
        this.toastmessage('Something went wrong', 'error');
      }
      else if (error.status === 403) {
        //message: "not-enough-credit"
        this.toastmessage('You don`t have enough credits!', 'error');
      }
      else if (error.status === 404) {
        //message: "no-details-found"
        this.candidateDetails['revealContactAttempted'] = 1;
        this.candidateDetails['existingContactDetails'] = [];

        const eventdata = {
          action: 'append-data',
          data: this.candidateDetails
        }
        this.aggRequestService.updateCandidate(this.elasticid,this.candidateDetails)
        this.handleOutputEvent.emit(eventdata);

        this.dataTransferToEmailCampaignSlider({});
      }
      else {
        this.toastmessage('Something went wrong', 'error');
      }
      this.isRevealContactLoading = false;
      this.isRevealContactEmailLoading = false;
    })
  }


  /**
   * Used to segregate personal email, professional email, and phone number from existing contactdetails object.
   */
  segregateContactDetails(existingContactDetails) {
    if (existingContactDetails) {
      this.work_email = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.contactdetailcategory == "professional" && x.type == 'email'
        }
      );
      this.personal_email = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.contactdetailcategory == "personal" && x.type == 'email'
        }
      );
      this.phones = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.type == 'contactnumber'
        }
      );
    }

    if (this.availableContactDetailNotManual) {
      this.candidateDetails['revealContactAttempted'] = 1;
      this.hasAnyOfRequestSuccess = true;
    }
  }

  /**
   * TRMS-2797: Lightweight check (reuses the v2 preview endpoint) to detect whether a
   * FullEnrich fallback job triggered by an earlier reveal click is still running in the
   * background for this candidate.
   */
  checkFullEnrichPendingStatus() {
    if (!this.elasticid) return;
    const elasticId = this.elasticid;
    const alreadyRevealed = !!this.candidateDetails?.revealContactAttempted;
    // The Reveal button (and the no-data panel) stay hidden until this resolves - see template.
    this.isPreviewPending = true;
    this.personSearchService.previewContactDetailsV2(elasticId).subscribe({
      next: (res: any) => {
        if (elasticId !== this.elasticid) return; // user already moved to another candidate
        const submittedThisSession = this.candidateSelectionService.isRevealSubmitted(elasticId);
        if (res?.pendingFullEnrich) {
          submittedThisSession && this.candidateSelectionService.markRevealSeenPending(elasticId);
          this.isFullEnrichPending = true;
          return this.finishStatusCheck();
        }
        if (submittedThisSession) {
          // A retry (already-revealed candidate) clears its own record when it responds without
          // FullEnrich, so a record left here means it's still running unless FullEnrich was seen
          // queued and has now finished.
          if (alreadyRevealed && !this.candidateSelectionService.isRevealSeenPending(elasticId)) {
            this.isFullEnrichPending = true;
            return this.finishStatusCheck();
          }
          // Not pending, but this candidate's object here predates a reveal/retry fired this session
          // (here, in an earlier slider, or via bulk) - load what it actually ended with.
          return this.loadSubmittedRevealOutcome(elasticId);
        }
        this.finishStatusCheck();
      },
      error: () => elasticId === this.elasticid && this.finishStatusCheck()
    });
  }

  /**
   * A reveal for this candidate was fired this session and isn't pending on FullEnrich now.
   * enrichresults returns the user's saved contacts / Reveal Contact action for it - if there's
   * neither, it either finished with nothing found (FullEnrich was seen queued and has since
   * resolved) or hasn't produced anything yet (bulk keeps working after it responds).
   */
  private loadSubmittedRevealOutcome(elasticId: string) {
    this.candidateSelectionService.fetchRevealStatusById([{ id: elasticId }], (c: any) => c.id).subscribe({
      next: (byId) => {
        if (elasticId !== this.elasticid) return;
        // Another check for this same candidate (the slider reloads this view when its own data arrives) already reached an
        // outcome and cleared the record - this one has nothing left to decide, and must not undo that result.
        if (!this.candidateSelectionService.isRevealSubmitted(elasticId)) return this.finishStatusCheck();
        const enriched = byId[elasticId];
        const contacts = enriched?.existingContactDetails || [];
        const finished = !!enriched?.revealContactAttempted || !!contacts.length || this.candidateSelectionService.isRevealSeenPending(elasticId);
        if (finished) {
          this.candidateSelectionService.clearRevealSubmitted(elasticId);
          // Same state the synchronous success / no-details-found branches of revealContact() leave behind.
          this.candidateDetails['revealContactAttempted'] = 1;
          // An answer without contacts must not erase the ones this candidate already has from its own data (getcandidatedetails).
          if (contacts.length) {
            this.candidateDetails['existingContactDetails'] = contacts;
            this.segregateContactDetails(contacts);
          }
          if (enriched?.candidatenumber) {
            this.candidateDetails['candidatenumber'] = enriched.candidatenumber;
            this.candidateNumber = enriched.candidatenumber;
          }
          this.aggRequestService.updateCandidate(elasticId, this.candidateDetails);
          this.handleOutputEvent.emit({ action: 'append-data', data: this.candidateDetails });
        } else {
          this.isFullEnrichPending = true;
        }
        this.finishStatusCheck();
      },
      error: () => {
        if (elasticId !== this.elasticid) return;
        this.isFullEnrichPending = true; // a reveal is known to be in flight - never offer another
        this.finishStatusCheck();
      }
    });
  }

  private finishStatusCheck() {
    this.isPreviewPending = false;
    if (this.revealAfterStatusCheck) {
      this.revealAfterStatusCheck = false;
      this.revealContact();
    }
  }

  /**
   * TRMS-2797: partialContactDetails on a pending reveal response uses the same provider-keyed
   * { work_email: [], personal_email: [], phone: [] } shape as candidateDetails.contactDetails[provider]
   * elsewhere in this component (see retryRevealContact()) - flatten it into the enrichedvia-tagged
   * list shape segregateContactDetails()/the existing templates already know how to render.
   * @param partialContactDetails Object keyed by provider name, e.g. { signalhire: { work_email: [], personal_email: [], phone: [] } }
   */
  mapPartialContactDetailsToContactList(partialContactDetails) {
    const flattened = [];
    Object.keys(partialContactDetails || {}).forEach((provider) => {
      const providerDetails = partialContactDetails[provider] || {};
      (providerDetails.work_email || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, contactdetailcategory: 'professional', type: 'email' }));
      (providerDetails.personal_email || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, contactdetailcategory: 'personal', type: 'email' }));
      (providerDetails.phone || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, type: 'contactnumber' }));
    });
    return flattened;
  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    let isExtensioninstalled
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'refreshExtension', candidateNumber: this.candidateNumber }, function (res) {
          if (res && res.similarCandidateData) {
            isExtensioninstalled = true
          }
        });
      } catch (error) {
        if (error) {
          isExtensioninstalled = false
        }
        console.error('Here is the error message', error);
      }
      setTimeout(() => {
        this.isExtensioninstalled = isExtensioninstalled
      }, 500)
    }
  }

  /**
 * Toast message
 * @param message Toast message
 * @param type type of action i.e. error, success, custom -> only used for reveal success
 */
  toastmessage(message: string, type: string) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error') {
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    } else if (type == 'custom') {
      this.customToast = true;
      setTimeout(() => this.customToast = false, 5000);
    }
  }

  /**
 * Function used to sent data in email campaing slider
 * @param data Contact details
 */
  dataTransferToEmailCampaignSlider(data) {
    if (this.enrichedfrom === 'email-campaign-target-listing') {
      this.campaignService.setContactSliderToListingData({ ...data, revealContactAttempted: this.candidateDetails?.revealContactAttempted });
    }
  }

  /**
 * Used to know either rednder in general or inside dropdown
 * @param div inital state/ Alternative source dropdown
 * @returns
 */
  isRenderCurrentDiv(div) {
    if (div === 'alternative-source') {
      //When any one of the process is done
      return !(this.candidateDetails?.iswebbtreeverified && this.candidateDetails?.usedWebbtreeIntroduction &&
        (this.candidateDetails?.revealContactAttempted || (!this.candidateDetails?.revealContactAttempted && this.isCloseNoDataFound))) &&
        (this.candidateDetails?.iswebbtreeverified || this.candidateDetails?.usedWebbtreeIntroduction || (this.candidateDetails?.revealContactAttempted || !this.isCloseNoDataFound))
    } else if (div === 'inital-state') {
      //When none of reveal operation triggers
      return (!this.candidateDetails?.iswebbtreeverified || !this.candidateDetails?.usedWebbtreeIntroduction || !this.candidateDetails?.revealContactAttempted)
    }
  }

  /**
   * WebtreeVerified and Webtree blocked for some domains
   * For Now Blocking all Internal Domains except some specific email.
   */
  isCurrentUserInternal() {
    const usertype = this.localstorageservice.getItem('userdata').usertypename;
    if (usertype === GlobalService.USER_TYPE.INTERNAL) return true;
    else return false;
  }

  getAllContactDetailsV2(calledFrom = '') {
    if (this.candidateDetails && this.candidateDetails.hasOwnProperty("candidatenumber")) {
      this.availableContactDetailNotManual = false;
      this.isFetchExistingContactPending = true

      const data = {
        usernumber: this.localstorageservice.getItem("usernumber"),
        candidatenumber: this.candidateDetails.candidatenumber,
      }
      // Fetch existing contact detail api
      this.candidateservice.getContactDetails(data).subscribe((result: any) => {
        if (result && result.status == 'success') {
          if (result?.data?.contactnumbers?.length) {
            this.phones = result.data.contactnumbers.filter(
              (x) =>{
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.type == "contactnumber"
              }
            );
          }
          if (result?.data?.emails?.length) {
            this.work_email = result.data.emails.filter(
              (x) =>{
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.contactdetailcategory == "professional"
              }
            );
            this.personal_email = result.data.emails.filter(
              (x) => {
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.contactdetailcategory == "personal"
              }
            );
          }
          if (this.availableContactDetailNotManual) {
            this.candidateDetails['revealContactAttempted'] = 1;
            this.hasAnyOfRequestSuccess = true;
          }
          // if(calledFrom == 'revealContactV2'){
          //   this.isRevealContactLoading = false;
          // }
          this.isFetchExistingContactPending = false;
          this.dataTransferToEmailCampaignSlider(result?.data);
        }
      })

      //TODO person searh listing update
      // let eventdata = {
      //   action: 'append-data',
      //   data: this.candidateDetails
      // }
    }
  }

  /**
   * Checks if retry is available for revealing contact information.
   * @returns {boolean} True if retry is available, false otherwise
   */

  isRetryAvailable() {
    return !this.internalUser && this.candidateDetails?.revealContactAttempted && !this.isPreviewPending && this.candidateDetails['isRevealRetryAvailable'] && (this.work_email?.length || this.phones?.length || this.personal_email?.length);
  }

/**
 * Checks if no data found after reveal attempt.
 * @returns {boolean} True if no data found after reveal attempt, false otherwise
 */

  noDataFoundAfterReveal() {

    return !this.isPreviewPending && (this.candidateDetails?.revealContactAttempted) && !(this.work_email?.length || this.phones?.length || this.personal_email?.length);
  }

   /**
   * Retry reveal contact after reveal is completed
   */
  retryRevealContact() {
    if (this.isRevealContactLoading) {
      return;
    }
    this.checkHasEnoughCredits(this.CREDITS_REQUIRED.RETRY_CONTACT_REVEAL, (hasEnough) => {
      if (!hasEnough) {
        this.toastmessage('You don`t have enough credits!', 'error');
        return;
      }
      this.doRetryRevealContact();
    });
  }

  private doRetryRevealContact() {
    const payload = {
      elasticId: this.elasticid,
      enrichedFrom: this.enrichedfrom
    }
    this.isRevealContactLoading = true;
    const retriedElasticId = this.elasticid;
    this.candidateSelectionService.markRevealSubmitted([retriedElasticId]);
    this.personSearchService.revealRetry(payload).subscribe((res: any) => {
      if (res.body.pendingFullEnrich) {
        this.candidateSelectionService.markRevealSeenPending(retriedElasticId);
      } else {
        this.candidateSelectionService.clearRevealSubmitted(retriedElasticId);
      }
      if (res.body.data) {
        const contactProviderDetails = res.body.data.newContactDetails;
        const candidateData = res.body.data.candidateData
        this.segregateContactDetails(candidateData.existingContactDetails);
        this.candidateDetails['existingContactDetails'] = candidateData.existingContactDetails;

        const providers = [];
        this.candidateDetails['contactDetails'] = candidateData.contactDetails
        Object.keys(contactProviderDetails).forEach((provider)=>{
          const providerDetails = candidateData.contactDetails[provider];
          if(providerDetails?.personal_email.length || providerDetails.work_email?.length || providerDetails?.phone.length){
            providers.push(provider);
          }
        })
        this.contactProviderData = providers;
        if (res.body.pendingFullEnrich) {
          // FullEnrich is still working on what SignalHire didn't find - show "still working on it"
          // alongside whatever the retry already found, same as a pending reveal.
          this.isFullEnrichPending = true;
        } else {
          this.contactProviderData.length && this.toastmessage('', 'custom');
        }
        this.candidateDetails['isRevealRetryAvailable'] = 0;
      }

      const candidateData = this.aggRequestService.data();
     this.aggRequestService.data().map((candidate)=>{
        if(candidate.id === this.elasticid){
          candidate = {...candidate, ...this.candidateDetails}
        }

        return candidate;
      })
      const eventdata = {
        action: 'append-data',
        data: { ...this.candidateDetails }
      }
      this.handleOutputEvent.emit(eventdata);
      this.aggRequestService.updateCandidate(this.elasticid, this.candidateDetails);
      this.isRevealContactLoading = false;
      this.isRevealContactEmailLoading = false;
    }, (err) => {
      // 409 = a reveal/retry for this candidate is genuinely running elsewhere - still in flight.
      if (err.status !== 409) {
        this.candidateSelectionService.clearRevealSubmitted(retriedElasticId);
      }
      this.toastmessage('Something went wrong', 'error');
    })
  }

    /**
     * Function used to Request Webtree Verified;
     */
    webtreeVerifiedRequest() {
      if (this.isVerifiedLoading) {
        return;
      }
      this.checkHasEnoughCredits(this.CREDITS_REQUIRED.WEBBTREE_VERIFIED, (hasEnough) => {
        if (!hasEnough) {
          this.toastmessage('You don`t have enough credits!', 'error');
          return;
        }
        this.doWebtreeVerifiedRequest();
      });
    }

    private doWebtreeVerifiedRequest() {
      const obj = { elasticid: (this.enrichedfrom == 'pipeline-listing' || this.filterService.isHirePieplineListing()) ? this.candidateDetails?.basicdetails?.elastic_id : this.candidateDetails.id || this.candidateDetails.idinindex , atsindexid: this.candidateDetails?.basicdetails?.elastic_id || null }
      this.isVerifiedLoading = true;
      this.requestContract.getRequestContract(obj).subscribe((res: any) => {
        if (res.status == "success") {
          this.candidateDetails["iswebbtreeverified"] = 1;
          this.hasAnyOfRequestSuccess = true;

        const ele = document.getElementById('contact-dropdown');
        ele && ele.classList.remove('show')
          let eventdata = {
            action: 'append-data',
            data: this.candidateDetails
          }
          this.handleOutputEvent.emit(eventdata);
          this.aggRequestService.updateCandidate(this.elasticid, this.candidateDetails);
          this.sendMessagetoChrome();
           /**
           * reveal contact from webbtree verified
           */
            const revealParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Candidate ID": this.elasticid,
              "Reveal Time": moment().format(),
              "Request Type": "Webbtree Verified",
              "Source": "Platform",
              "Reveal Complete": "Yes",
            }
            clevertap.event.push('Explore Contact', revealParams);

        } else {
          this.toastmessage('You don`t have enough credits!', 'error')
        }
        this.isVerifiedLoading = false;
      })
    }

      /**
   * Used to track activity of user when clicked on candidate's contact details
   * @param data
   */
  trackClickActivity(data) {
    const payload = {
      type: data.type,
      contactdetail: data.contactdetail,
      contactdetailcategory: data.contactdetailcategory,
      candidatenumber: this.candidateNumber,
      clickedFrom: this.enrichedfrom
    }
    this.deb.next(payload);
  }

    markContactValidity(contactDetailObject, isValid) {
    const payload = {
      usernumber: this.localstorageservice.getItem("usernumber"),
      candidatenumber: this.candidateDetails.candidatenumber,
      isvalid: Number(isValid),
      candidatecontactdetailid: contactDetailObject.candidatecontactdetailid
    }
    this.personSearchService.markContactValidity(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.successMessage = "Marked validity for contact successfully";
        setTimeout(() => this.successMessage = '', 3000);
      }
    }, (err: any) => {
      console.log("markContactValidity() err", err);
      this.errorMessage = "Something went wrong";
      setTimeout(() => this.errorMessage = '', 3000);
    }).add(() => this.getAllContactDetailsV2());
  }

  copyToClipboard(content: string) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = content;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Contact detail copied successfully"
    setTimeout(() => this.successMessage = '', 3000);
  }

    OpenSendEmailModule(preSelectEmail: string = null) {
      if (this.localstorageservice.getItem('secredits') > 0) {
        const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
        modalRef.componentInstance.emailforCandidate = this.candidateDetails ? { ...this.candidateDetails, basicdetails: { firstname: this.candidateDetails.first_name, lastname: this.candidateDetails.last_name }, contactdetails: { emails: { existingDetails: this.candidateDetails.existingContactDetails.filter(c => c.type === 'email') } } } : null
        modalRef.componentInstance.preSelectEmail = preSelectEmail
        modalRef.componentInstance.candidatenumber = this.candidateDetails.candidatenumber,
          modalRef.componentInstance.passEntry.subscribe((x) => {
            if (x == 'emailsend') {
              this.toastmessage('Email Send Successfully', 'success')
            } else if (x == 'nocredits') {
              this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
              this.sendmailexpiry('Smart Email credits')
            } else if (x == 'limitexceeded') {
              this.toastmessage('mail limit exceeded', 'error')
            } else if (x == 'error') {
              this.toastmessage('Something went Wrong', 'error')
            }
          });
      } else {
        this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
        this.sendmailexpiry('Smart Email credits')
      }
    }

  sendmailexpiry(type) {
    let data = {
      expiredmetric: type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

    getWhatsappLink(phonenumber: string) {
    return `https://api.whatsapp.com/send/?phone=${phonenumber.trim().replace(/[\+\-\s]/g, '')}`;
  }

    /**
   * Length of Form Group used to know the count of sub-forms present
   */
  formLength() {
    const innerFormGroup = this.dateTimeMasterForm.controls;
    return Object.keys(innerFormGroup);
  }

    /**
   * Used to add new form group for date and time slots
   */
  addNewDateTimeFormSlot() {
    this.validateWebtreeIntoductionForm();
    if (this.dateTimeMasterForm.status === 'VALID') {
      const uniqueId = GlobalService.generateUniqueId();
      const fromGroup = this.dateTimeMasterForm;
      fromGroup.addControl(`dateTimeSlot_${uniqueId}`, new UntypedFormGroup({
        date: new UntypedFormControl(),
        fromTime: new UntypedFormControl('14:00'),
        toTime: new UntypedFormControl('16:00'),
        timezone: new UntypedFormControl(TimezonesService.timeZoneAbbrevation([Intl.DateTimeFormat().resolvedOptions().timeZone]))
      }));
    }
  }

  /**
   * Used to remove date time slots from form group
   * @param formGroup Name of form group which we want to remove.
   */
  deleteDateTimeFormSlot(formGroup: string) {
    this.dateTimeMasterForm.removeControl(formGroup);
  }

    /**
   * Check dateTimeMasterForm validity.
   */
  validateWebtreeIntoductionForm() {
    this.dateTimeSlotsArray = Object.keys(this.dateTimeMasterForm.value).map(x => this.dateTimeMasterForm.value[x]) || [];
    const dateTimeSet = new Set();
    this.dateTimeSlotsArray.map(slot => {
      const str = JSON.stringify(slot);
      if (dateTimeSet.has(str)) {
        this.dateTimeMasterForm.setErrors({ duplicate: true });
      } else { dateTimeSet.add(str); }
      if (!slot.date || !slot.fromTime || !slot.toTime || !slot.timezone) {
        this.dateTimeMasterForm.setErrors({ invalidValues: true });
      }
      const minDiff = this.differenceInMinutes(slot.fromTime, slot.toTime);
      if (minDiff < 0) {
        this.dateTimeMasterForm.setErrors({ timeDiff: true });
      }
    });
  }

    /**
 * Calculates difference in minutes between two times
 * @param time1
 * @param time2
 * @returns
 */
  differenceInMinutes(time1: string, time2: string): number {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const hoursDiff = Number(hours2) - Number(hours1);
    const minutesDiff = Number(minutes2) - Number(minutes1);
    const minDiff = hoursDiff * 60 + minutesDiff;
    return minDiff;
  }

    /**
     * Function used for Webtree Introduction
     * Require valid text message and date time slots
     */
    webtreeIntroductionRequest() {

      this.validateWebtreeIntoductionForm();
      this.webbtreeIntroductionMessageForm.markAsTouched();

      const webtreeIntroMessage = this.webbtreeIntroductionMessageForm.value;
      const dateTimeSlots = this.dateTimeSlotsArray;
      const obj = { elasticid: (this.enrichedfrom == 'pipeline-listing' || this.filterService.isHirePieplineListing() || this.calledFrom == 'my-candidates') ? this.candidateDetails?.basicdetails?.elastic_id : this.candidateDetails.id || this.candidateDetails.idinindex,atsindexid: this.candidateDetails?.basicdetails?.elastic_id || null, requirement: webtreeIntroMessage, preferences: dateTimeSlots }
      if (obj.elasticid && obj.requirement && obj.preferences?.length && this.dateTimeMasterForm.status === 'VALID') {
        this.isIntroductionLoading = true;
        this.personSearchService.makeRequestContact(obj).subscribe((res: any) => {
          if (res.status == "success") {
            this.hasAnyOfRequestSuccess = true
            this.candidateDetails["usedWebbtreeIntroduction"] = 1;
            let eventdata = {
              action: 'append-data',
              data: this.candidateDetails
            }

            const ele = document.getElementById('contact-dropdown');
            ele && ele.classList.remove('show');

            this.handleOutputEvent.emit(eventdata);
            this.sendMessagetoChrome();
              /**
           * reveal contact from webbtree introduction
           */
               const revealParams = {
                "User ID": this.localstorageservice.getItem('userdata').userid,
                "Candidate ID": this.elasticid,
                "Reveal Time": moment().format(),
                "Request Type": "Webbtree Introduction",
                "Source": "Platform",
                "Reveal Complete": "Yes",
              }
              clevertap.event.push('Explore Contact', revealParams);

            this.toastmessage('We have successfully submitted your request ', 'success')
          } else {
            this.toastmessage('You don`t have enough credits!', 'error')
          }
          this.isIntroductionLoading = false;
        })
      }

  }

getEnrichedType() {
  if(this.searchType) {
    this.enrichedfrom = this.searchType;
  } else if(this.calledFrom == 'Project') {
    this.enrichedfrom = 'project-candidate-listing';
  } else if(this.calledFrom == 'pipeline-list') {
    this.enrichedfrom = 'pipeline-listing';
  } else if(this.calledFrom == 'project-upload-candidates') {
    this.enrichedfrom = 'project-upload-candidates';
  } else if(this.calledFrom == 'project-inbound-applications') {
    this.enrichedfrom = 'project-inbound-applications';
  } else {
    this.enrichedfrom = 'person-search-listing';
  }
}


}
